// const apiurl =process.env.NODE_ENV==='production'?'https://cloud.weimiopen.com':"/api"
const apiurl =process.env.NODE_ENV==='production'?'http://m.gupm.net':"/api"

export default apiurl
